module.exports = __webpack_public_path__ + "img/BETFURY.272c29c2.svg";